<template>
<v-dialog
  v-model="pgRequestVisible"
  max-width="712px"
  persistent>
  <v-card id="popStyle02" class="poPpaying">
    <!--팝업 내용-->
    <v-card-text v-if="pgVisible">
      <v-row no-gutters class="justify-center popCon">
        <div class="round8_pd20_box row_mb-40">
          <ul class="pattern_ulTxtBox li">
            <li>
              <span class="txt_tt">계약 발신</span>
              <!--conFrom:개인, conFrom st_cpn:기업-->
              <v-chip class="conFrom">개인</v-chip>
            </li>
            <li>                
              <span class="txt_tt">발행요금</span>
              <span class="txt_txt01 fc_p02">3,300원(3,000P)</span>
            </li>
          </ul>
        </div>
        <v-col cols="12" class="row_mb-20">
          <div class="dot_tt16 ta_left">부가정보 등록</div>
          <v-radio-group class="radioCon" v-model="ctrChoicePay" row>
            <v-radio
            label="신용카드"
            value="SC0010"
          ></v-radio>
          <v-radio
            label="실시간계좌이체"
            value="SC0030"
          ></v-radio>
          <v-radio
            label="휴대폰 결제"
            value="SC0060"
          ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-if="LgpgVisible">
      <form type="hidden" id="pgRequestForm" ref="pgRequestForm" target="pgframe" :action="payreqCrossplatform">
        <input type="hidden" name="LGD_BUYER" id="LGD_BUYER" :value="paymentBuyer" />
        <input type="hidden" name="PAY_CHAINADDR" id="PAY_CHAINADDR" :value="payment.chainAddr" />
        <input type="hidden" name="LGD_BUYEREMAIL" id="LGD_BUYEREMAIL" :value="paymentEmail" />
        <input type="hidden" name="LGD_OID" id="LGD_OID" :value="'sec'+makeoid()" />
        <input type="hidden" name="LGD_ID" id="LGD_ID" :value="paymentBuyer" />
        <input type="hidden" name="LGD_PRODUCTINFO" id="LGD_PRODUCTINFO" value="글로싸인 엔터프라이즈 사용료" />
        <input type="hidden" name="LGD_PRODUCTCODE" id="LGD_PRODUCTCODE" value="SEC" />
        <input type="hidden" name="LGD_AMOUNT" id="LGD_AMOUNT" value="3300" />
        <input type="hidden" name="LGD_TIMESTAMP" id="LGD_TIMESTAMP" :value="makeoid()" />
        <input type="hidden" name="LGD_CUSTOM_USABLEPAY" id="LGD_CUSTOM_USABLEPAY" :value="ctrChoicePay" />
        <input type="hidden" name="PAY_ACTIVENAME" id="PAY_ACTIVENAME" value="personal" />
        <input type="hidden" name="CTR_STAT" id="CTR_STAT" :value="payment.ctrStat" />
        <input type="hidden" name="CTR_SEQ" id="CTR_SEQ" :value="contractDetailInfo.contSeq" />
        <input type="hidden" name="CTR_NUM" id="CTR_NUM" :value="contractDetailInfo.contractNumber" />
      </form>
      <iframe width="100%" :height= "LgpgVisible?'650px':'0px'" id="pgframe" ref="pgframe" name="pgframe">
      </iframe>
    </v-card-text>
    <!--/팝업 내용-->
    <!--팝업 버튼-->
    <v-card-actions class="justify-center">
      <v-btn text class="btnC01" @click="PG_SUBMIT">결제하기</v-btn>
      <v-btn text @click="close">취소</v-btn>
    </v-card-actions>
    <!--/팝업 버튼-->
  </v-card>
    <s-confirm ref="confirm"></s-confirm>
  	<s-loading ref="loading"></s-loading>
</v-dialog>
</template>
<script>

export default {
  name: 'pgRequest',
  components: {
  },
  filters: {
  },
  props:{
    signal: String,
    contractDetailInfo: {}
  },
  data () {
    return {
      payreqCrossplatform: process.env.VUE_APP_URL_PAYREQ_CROSSPLATFORM,
      ctrSeq: '',
      ctrChoicePay: 'SC0010',
      paymentBuyer: '',
      paymentChainAddr: '',
      paymentEmail: '',
      senderAddress: '',
      pgRequestVisible: false,
      pgVisible : true,
      LgpgVisible : false,
      // PG 관련 파라미터
      payment: {
        // 결제자
        buyer: '',
        // 결제자 체인주소
        chainAddr: '',
        // 결제자 이메일
        buyerEmail: '',
        // 결제금액
        amount: 3300,
        // OID
        oid: 'sec' + this.makeoid(),
        // 시간값
        timestamp: this.makeoid(),
        // 결제 방법
        payMethod: 'SC0010',
        // 결제자 시그널
        activeName: 'personal',
        // 계약 시그널
        ctrStat: 'CC',
        // 계약서 번호
        ctrNo: ''
      },
      pgSeq: null,
      reqParamJson: {},
      payCnt: 0,
    }
  },
  created () {
  },
  mounted () {
    
    
  },
  methods: {
    open () {
      window.addEventListener('message', this.PGValidate, true)
      this.ctrSeq = this.contractDetailInfo.contSeq
      this.paymentBuyer = this.$store.state.user.userid
      this.paymentEmail = this.$store.state.user.useremail
      this.pgSetting()
    },
    pgSetting () {
      this.payment.buyerEmail = this.$store.state.user.useremail
      if (this.signal === 'BROKER') {
        this.payment.buyer = this.$store.state.user.orgname
        this.payment.chainAddr = this.$store.state.user.orgaddr
      } else if (this.signal === 'PERSONAL') {
        this.payment.buyer = this.$store.state.user.username
        this.payment.chainAddr = this.$store.state.user.useraddr
      }
      this.pgVisible = true
      this.pgRequestVisible = true
    },
    // [PG 관련] 결제를 submit 해주는 함수
    PG_SUBMIT () {
      this.payCnt = 0
      this.$nextTick(() => {
        this.pgVisible = false
        this.LgpgVisible = true
        this.$refs.loading.start('결제창이 열리는 중입니다.')
        setTimeout(() => {
          this.payRequest()
          this.$refs.loading.end()
        }, 3000)
      })
    },
    payRequest() {
      if(this.payCnt < 10) {
        if(this.$refs.pgRequestForm !== undefined) {
          this.$refs.pgRequestForm.submit()
        }else {
          this.payCnt++
          this.payRequest()
        }
      }
    },
    // [PG 관련] 시간값 만들어주기 위한 포메터
    LPad (digit, size, attatch) {
      var add = ''
      digit = digit.toString()

      if (digit.length < size) {
        var len = size - digit.length
        for (var i = 0; i < len; i++) {
          add += attatch
        }
      }
      return add + digit
    },
    // [PG 관련] 시간값 만들어주는 함수
    makeoid () {
      var now = new Date()
      var years = now.getFullYear()
      var months = this.LPad(now.getMonth() + 1, 2, '0')
      var dates = this.LPad(now.getDate(), 2, '0')
      var hours = this.LPad(now.getHours(), 2, '0')
      var minutes = this.LPad(now.getMinutes(), 2, '0')
      var seconds = this.LPad(now.getSeconds(), 2, '0')
      var timeValue = years + months + dates + hours + minutes + seconds

      return timeValue
    },
    // [PG 관련] 결제 다이얼로그가 닫히기전에 핸들링하는 함수
    handleCloseorgPG (done) {
      this.cancelClose()
    },
    // [PG 관련] 결제 다이얼로그가 닫히기전에 핸들링하는 함수
    cancelClose () {
      if (this.pgVisible) {
        this.PGFail()
      } else {
        this.$refs.confirm.open('confirm', '결재', '결제가 완료되지 않았습니다. 결제가 완료되지 않은 경우 서비스를 진행할수 없습니다.').then(() => {
        }).catch(e => {
          this.PGFail()
        })
      }
    },
    // [PG 관련] 결제 실패 시 호출 되는 함수
    PGFail () {
      this.pgRequestVisible = false
      this.paymentBuyer = ''
      this.paymentChainAddr = ''
      this.paymentEmail = ''
      this.ctrChoicePay = 'SC0010'
      this.LgpgVisible = false
    },
    PGDone () {
      this.pgRequestVisible = false
      this.$emit('pgEvent', this.pgSeq)
    },
    PGValidate (e) {
      if (e.data.auth !== undefined && !this.pgVisible && this.pgRequestVisible) {
        if (e.data.auth === 'true') {
          this.pgSeq = e.data.pgSeq
          this.PGDone()
          // this.requestValidatePG()
        } else {
          this.PGFail()
        }
      }
    },
    close() {
      this.pgRequestVisible = false
      this.payment.buyer = ''
      this.payment.chainAddr = ''
      this.payment.buyerEmail = ''
      this.payment.payMethod = 'SC0010'
      this.LgpgVisible = false
    }
  }
}
</script>